import api from './axios';

export const chatApi = {
    // 대화방 목록 조회 (프로젝트 필터링 추가)
    getConversations: (projectId) => api.get(`chat/conversations/${projectId ? `?project=${projectId}` : ''}`),

    // 대화방 생성 (1:1 또는 그룹)
    createConversation: (data) => api.post('chat/conversations/', data),

    // 1:1 대화방 가져오기 또는 생성 (프로젝트 범위 내)
    getOrCreate1on1: (userId, projectId) => api.post('chat/conversations/get-or-create/', {
        user_id: userId,
        project_id: projectId
    }),

    // 특정 대화방 메시지 내역 조회
    getMessages: (conversationId) => api.get(`chat/messages/?conversation=${conversationId}`),

    // 읽음 처리
    markAsRead: (conversationId) => api.post('chat/messages/mark-read/', { conversation_id: conversationId }),
};
